import { CSSProperties } from 'react';

export default function NotificationIcon({ s }: { s?: CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3412_20030)" />
      <path
        d="M29.4491 25.5569L27.3764 21.4136C27.2921 21.269 27.2559 21.1016 27.2559 20.9209V17.7158C27.2559 14.1145 24.6048 11.1165 21.1463 10.5504V9.08338C21.1463 8.41852 20.6077 7.87891 19.9413 7.87891C19.2749 7.87891 18.7362 8.41852 18.7362 9.08338V10.5504C15.2778 11.1165 12.6267 14.1145 12.6267 17.7158V20.9209C12.6267 21.1016 12.5905 21.269 12.5061 21.4136L10.4334 25.5569C10.2407 25.9302 10.2647 26.3771 10.4817 26.7264C10.6986 27.0878 11.0842 27.3045 11.506 27.3045H28.3766C28.7983 27.3045 29.184 27.0877 29.4009 26.7264C29.6178 26.3771 29.6419 25.9302 29.4491 25.5569ZM21.1463 29.1102H16.1454C16.543 30.8326 18.0975 32.1213 19.9413 32.1213C21.785 32.1213 23.3395 30.8326 23.7372 29.1102H21.1463Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3412_20030"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6F3DFD" />
          <stop offset="1" stopColor="#1399D6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
